import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
const {FiGlobe,FiGithub,FiMail,FiCalendar}=FiIcons;

const Footer=()=> {
  return (
    <motion.footer 
      initial={{opacity: 0}} 
      animate={{opacity: 1}} 
      className="bg-gray-900 text-white mt-12"
    >
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <SafeIcon icon={FiGlobe} className="text-blue-400 text-xl" />
              <h3 className="text-lg font-semibold">Iligan Disaster Risk Portal</h3>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Real-time multi-hazard monitoring dashboard providing comprehensive coverage of earthquakes,volcanic eruptions,floods,tsunamis,and weather hazards across Iligan City.
            </p>
            <div className="flex items-center space-x-2 text-sm text-gray-500">
              <SafeIcon icon={FiCalendar} className="text-gray-500" />
              <span>© 2025 Iligan Disaster Risk Portal</span>
            </div>
          </div>
          
          <div>
            <h4 className="font-medium mb-3">Data Sources</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>• PHIVOLCS</li>
              <li>• PAGASA</li>
              <li>• USGS</li>
              <li>• GDACS</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-500 mb-4 md:mb-0">
              This platform aggregates data from official monitoring agencies and provides real-time alerts for public safety.
            </div>
            <div className="flex items-center space-x-4">
              <a 
                href="https://kalmap.org" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center space-x-2 text-blue-400 hover:text-blue-300 transition-colors"
              >
                <SafeIcon icon={FiGlobe} />
                <span className="text-sm font-medium">Powered by kalmap.org</span>
              </a>
              <div className="flex items-center space-x-3">
                <a href="mailto:info@kalmap.org" className="text-gray-400 hover:text-white transition-colors">
                  <SafeIcon icon={FiMail} />
                </a>
                <a href="https://github.com/kalmap" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                  <SafeIcon icon={FiGithub} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;